import { useSelector } from "react-redux";
import { useRef, useState, useEffect } from "react";
import notificationImage from "../../../assets/smarthome/securitySection/Notifications.jpg";
import senOpenMod from "../../../assets/smarthome/securitySection/senOpenMod.png";
import senMotionLightMod from "../../../assets/smarthome/securitySection/senMotionLightMod.png";
import textContentSmarthomeContactUsSection from "../ui/textContent-smarthome-contactUsSection";
import textContentSmarthomeProductSection from "../ui/textContent-smarthome-ProductSection";

export default function SecuritySection(props) {
  const { textContent, language } = { ...props };
  const isMobile = useSelector((state) => state.screen.isMobile);
  const screenWidth = useSelector((state) => state.screen.screenWidth);

  const deviceCard = (title, subtitle, image, productURL) => {
    return (
      <div className="security-sensor-item ">
        <h3 className="h3-bold h3-security-sensor-item">{title}</h3>
        <h4 className="h4-security-sensor-item">{subtitle}</h4>
        <img
          src={image}
          aria-hidden="true"
          // className="automation-item-icon"
        />
        <a href={productURL} className="learn-more-button">
          {
            textContentSmarthomeContactUsSection.learnMoreSection.title[
              language
            ]
          }
        </a>
      </div>
    );
  };

  return (
    <section className="container security-section">
      <div className={`container-small ${isMobile ? "smart-mobile" : ""}`}>
        <h1 className="title-gradient">
          {textContent.securitySection.title[language]}
        </h1>
        <h2>
          {textContent.securitySection.items.notifications.title[language]}
        </h2>
        <p>
          {
            textContent.securitySection.items.notifications.description[
              language
            ]
          }
        </p>
      </div>
      <div className="container-empty-small" />
      <div className="security-section-title-img-mobile">
        <img src={notificationImage} />
      </div>

      <div className="security-sensor-content">
        <div
          className={
            isMobile ? "container-empty-small" : "container-empty-small"
          }
        />
        <div className="container-small">
          <h2 className="h2-bold">
            {textContent.securitySection.items.sensors.title[language]}
          </h2>
          <p>
            {textContent.securitySection.items.sensors.description[language]}
          </p>
        </div>
        <div
          className={
            isMobile ? "container-empty-extra-small" : "container-empty-small"
          }
        />
        <div
          className={`grid-2 security-sensors ${screenWidth < 1000 ? "carousel" : ""}`}
        >
          {deviceCard(
            textContent.securitySection.items.sensors.functions.open.title[
              language
            ],
            textContent.securitySection.items.sensors.functions.open
              .description[language],
            senOpenMod,
            textContentSmarthomeProductSection.productSection.items.products
              .productsList.OPEN_1.link,
          )}
          {deviceCard(
            textContent.securitySection.items.sensors.functions.light.title[
              language
            ],
            textContent.securitySection.items.sensors.functions.light
              .description[language],
            senMotionLightMod,
            textContentSmarthomeProductSection.productSection.items.products
              .productsList.OPEN_1.link,
          )}
        </div>
      </div>
    </section>
  );
}
